import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { isUndefined } from 'lodash-es'

import { LoaderComponent } from '..'

import './LoaderWrapperComponent.scss'

class LoaderWrapperComponent extends React.Component {
  constructor(props) {
    let state
    super(props)

    if (props.useDelay) {
      this.delaySpinnerState()
      state = {
        showSpinner: false,
      }
    } else {
      state = {
        showSpinner: props.loading,
      }
    }

    this.state = state
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { loading } = this.props
    if (nextProps.useDelay && !loading && nextProps.loading) {
      this.delaySpinnerState()
      return
    }

    if (loading !== nextProps.loading) {
      this.setState({
        showSpinner: nextProps.loading,
      })
    }
  }

  componentWillUnmount() {
    clearTimeout(this.delayTimeout)
  }

  delaySpinnerState() {
    const { timeout } = this.props
    this.delayTimeout = setTimeout(() => {
      const { loading } = this.props
      this.setState({
        showSpinner: loading,
      })
    }, timeout)
  }

  renderChildren() {
    const { blur, children } = this.props
    const { showSpinner } = this.state

    if (blur || !showSpinner) {
      return <div className="children">{children}</div>
    }

    return null
  }

  renderWaitingState() {
    const { showSpinner } = this.state
    if (!showSpinner) {
      return null
    }

    const loader = <LoaderComponent {...this.props} />

    const { loadingMessage } = this.props

    if (!loadingMessage) {
      return loader
    }

    return (
      <>
        {loader}
        <div className="loading-message">{loadingMessage}</div>
      </>
    )
  }

  render() {
    const { blur, loading, loadingMessage } = this.props
    const { showSpinner } = this.state

    const classNames = classnames('loader-wrapper-component', {
      blur: blur && showSpinner,
      'is-loading': loading,
      'with-message': !isUndefined(loadingMessage),
    })

    return (
      <div className={classNames}>
        {this.renderWaitingState()}
        {this.renderChildren()}
      </div>
    )
  }
}

LoaderWrapperComponent.propTypes = {
  children: PropTypes.node,
  useDelay: PropTypes.bool,
  loading: PropTypes.bool,
  timeout: PropTypes.number,
  blur: PropTypes.bool,
  loadingMessage: PropTypes.string,
}

LoaderWrapperComponent.defaultProps = {
  timeout: 1000,
  blur: false,
  useDelay: false,
  loading: false,
}

export default LoaderWrapperComponent
